var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppDrawer'),_c('AppBar'),_c('v-main',[_c('v-container',{staticClass:"admin-design__container",attrs:{"fluid":""}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }